<template>
  <div
    class="card card-sm card--elevated p-relative overlay clickable-item"
    style="height: 92%;"
    @click.prevent="openProgramDetail()"
  >
    <span class="js-image d-flex justify-content-center clickable-item" data-position="left" :data-height="168">
      <b-badge
        variant="primary"
        class="mt-2 mr-2 d-flex justify-content-center"
        style="font-size: 0.81rem ; width:100px; position:absolute; left: 9px;"
      >
        {{ $t(`programTypeOptions.${program.type}`) }}
      </b-badge>
      <div class="" v-if="program.schedule_type == 'self_paced' || get(nextClass, `${program.id}.is_self_paced`)">
        <b-badge
          variant="secondary"
          class="mt-2 ml-2 d-flex justify-content-center"
          :style="{ top: get(program, 'type') ? '25px' : '0px' }"
          style="font-size: 0.81rem ; width:100px; position:absolute; left: 0;"
        >
          Self-Paced
        </b-badge>
      </div>
      <img :src="program.image" alt="cna" class="career-card-img" />
    </span>

    <div
      class="d-flex p-2"
      style="font-size: large; font-weight: bold;"
      :style="{ justifyContent: program.hide_tuition_fee ? 'center' : '' }"
    >
      {{ program.title }}
    </div>
    <div class="card-body d-flex flex-column justify-content-center p-0">
      <div v-if="get(program, 'prgType') === 'referred'" class="text-center text-primary mt-1">
        Offered by {{ get(program, 'school.name', 'our affiliate.') }}
      </div>
      <div class="d-flex justify-content-center mb-2">
        <b-badge
          variant="dark"
          class="mt-2 d-flex justify-content-center"
          style="font-size: 0.81rem ; width:110px;"
          v-if="get(program, 'prgType') === 'referred'"
        >
          Referred
        </b-badge>
      </div>

      <div
        class="row"
        :class="{
          'justify-content-center': get(this.nextClass, `${this.program.id}.is_self_paced`) || program.hide_tuition_fee,
        }"
      >
        <div
          v-if="!program.hide_tuition_fee"
          class="d-flex mb-2"
          :class="{
            'col-6 justify-content-left':
              program.duration_type && !get(this.nextClass, `${this.program.id}.is_self_paced`),
            'col-12 justify-content-center mt-1': !(
              program.duration_type && !get(this.nextClass, `${this.program.id}.is_self_paced`)
            ),
          }"
        >
          <div class="d-flex flex-column px-2">
            <span class="card-title" style="font-size: small; color: grey">{{
              get(getCurrentSchool, 'ttl_tuition_name') || 'Total Tuition'
            }}</span>
            <div class="d-flex" style="flex-direction: row;">
              <h4 class="mb-0">
                <span
                  :style="{
                    fontSize: '1.2rem',
                    color: program.enable_discount ? get(getCurrentSchool, 'secondary_color', '#2F6FED') : 'inherit',
                  }"
                  >{{ $n(totalTuition, 'currency', 'en-US') }}</span
                >
              </h4>
              <span
                v-if="program.enable_discount"
                class="text-muted ml-2"
                style=" text-decoration: line-through; font-size: medium; align-self: center;"
                >{{ $n(totalInitTuition, 'currency', 'en-US') }}</span
              >
            </div>

            <span
              v-if="program.enable_discount"
              :style="{ color: get(getCurrentSchool, 'secondary_color', '#2F6FED') }"
            >
              Save {{ $n(totalInitTuition - totalTuition, 'currency', 'en-US') }}
            </span>
            <span v-if="program.other_fees" class="text-muted" style="font-size: small">
              + {{ $n(program.other_fees, 'currency', 'en-US') }} other fees
            </span>
          </div>
        </div>
        <div
          v-if="program.duration_type && !get(this.nextClass, `${this.program.id}.is_self_paced`)"
          class="d-flex align-items-center"
          :class="{
            'col-6 justify-content-end': !program.hide_tuition_fee,
            'col-12 justify-content-center mt-1': program.hide_tuition_fee,
          }"
          style=""
        >
          <div class="d-flex flex-column mr-2">
            <span class="card-title" style="font-size: small;  color: grey">{{
              $t(`durationTypesEn.${program.duration_type}`)
            }}</span>
            <h4 class="text-center">{{ program.duration }}</h4>
          </div>
        </div>
      </div>
    </div>

    <div class=" card-footer p-3" style="font-size: 14px">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <div class="d-flex justify-content-center mt-2">
            <b-skeleton width="60%"></b-skeleton>
          </div>
        </template>
        <div class="d-flex justify-content-center">
          <span
            v-if="get(this.nextClass, `${this.program.id}.is_self_paced`) || get(program, 'prgType') === 'referred'"
            class="text-center py-2"
            :style="
              `background:rgb(${rgbPrimaryColor.r}, ${rgbPrimaryColor.g}, ${rgbPrimaryColor.b}, 10%); border-radius: 6px; padding: 0.5px 15px; width:100%;`
            "
          >
            Enroll Today
          </span>
          <span
            class="text-break font-weight-bold text-center py-2 justify-content-center align-content-center"
            style="width:100%; display: flex; align-items: center;"
            :style="
              `background:rgb(${rgbPrimaryColor.r}, ${rgbPrimaryColor.g}, ${
                rgbPrimaryColor.b
              }, 10%); border-radius: 6px; padding: 0.5px 15px;
              color: ${get(getCurrentSchool, 'primary_color', '#181818')};`
            "
            v-else-if="
              get(this.nextClass, `${this.program.id}.incoming_class`) &&
                !get(this.nextClass, `${this.program.id}.is_self_paced`)
            "
          >
            <md-icon
              class="mr-1"
              style="align-self: center;"
              :style="{ fontSize: 'medium', color: get(this.getCurrentSchool, 'primary_color', '#181818') }"
            >
              date_range
            </md-icon>
            Next Class on {{ formatDateSimple(get(this.nextClass, `${this.program.id}.incoming_class`)) }}
          </span>
          <span
            class="text-muted text-center text-break py-2 justify-content-center align-content-center"
            style="width:100%;display: flex; align-items: center;"
            v-else
            :style="
              `background:rgb(${rgbSecondaryColor.r}, ${rgbSecondaryColor.g}, ${rgbSecondaryColor.b}, 10%); border-radius: 6px; padding: 0.5px 15px;
              `
            "
            ><md-icon
              class="mr-1"
              style="align-self: center;"
              :style="{ fontSize: 'medium', color: get(this.getCurrentSchool, 'secondary_color', '#181818') }"
              >info</md-icon
            >
            <a class="text-secondary" @click.stop="openInfoModal"> Request More Information </a>
          </span>
        </div>
      </b-skeleton-wrapper>
    </div>
    <info-modal :showModal="showInfoModal" :program="{ id: program.id }" @close="hideInfoModal" />
  </div>
</template>

<script>
import { get } from 'lodash';
import { formatDateSimple } from '@/common/utils';
import { hexToRgb } from '../../../common/utils';
import InfoModal from './InfoModal/InfoModal.vue';
import { mapGetters } from 'vuex';
export default {
  props: {
    program: { type: Object, default: null },
    nextClass: { type: Object, default: null },
  },
  components: { InfoModal },
  data() {
    return {
      isLoading: false,
      showInfoModal: false,
    };
  },

  computed: {
    ...mapGetters('school', ['getCurrentSchool']),
    rgbPrimaryColor() {
      return hexToRgb(get(this.getCurrentSchool, 'primary_color', '#181818'));
    },
    rgbSecondaryColor() {
      return hexToRgb(get(this.getCurrentSchool, 'secondary_color', '#181818'));
    },
    totalTuition() {
      return get(this.program, 'tuition_fee', 0) + get(this.program, 'application_fee', 0);
    },
    totalInitTuition() {
      return get(this.program, 'initial_fee', 0) + get(this.program, 'application_fee', 0);
    },
  },

  methods: {
    get,
    openInfoModal() {
      this.showInfoModal = true;
    },

    hideInfoModal() {
      this.showInfoModal = false;
    },
    formatDateSimple,
    openProgramDetail() {
      if (get(this.program, 'prgType') === 'referred') {
        // open in new tab
        window.open(
          `${get(this.program, 'school.subdomain.subdomain_url')}/programs/${this.program.slug}?affid=${get(
            this.getCurrentSchool,
            'affiliation_id',
            ''
          )}`,
          '_blank'
        );
      } else {
        this.$router.push({ name: 'program-detail', params: { slug: this.program.slug } });
      }
    },
  },

  async mounted() {},
};
</script>

<style></style>
